import {useEffect, useState} from "react";
import {useParams} from "react-router-dom";
import {NumberUtil} from "base/utilities";

import {EntityViewPanel} from "base/entity";
import {SectionCard, SectionField} from "base/component/presentational";

import Box from "@mui/material/Box";
import {CountriesAndRegionsService} from "../countriesandregions/CountriesAndRegionsService";

export const ViewPanel = () => {
    const {id} = useParams();

    const [entityState, setEntityState] = useState(null);

    useEffect(() => {
        CountriesAndRegionsService.get(id).then(data => {
            setEntityState(data);
        });
    }, [id]);

    return (
        entityState && (
            <EntityViewPanel title="Countries and Regions" showDetailButton={false}>
                <SectionCard title={`${entityState.name}`}>
                    <SectionField label="Name:" value={entityState.name} />
                    <SectionField label="Type:" value={entityState.type} />
                    <SectionField
                        label="Current GVA:"
                        value={
                            <Box>{NumberUtil.formatDecimal(entityState.gva_me)}</Box>
                        }
                        unit="€ million"
                        notEmptyValue={!!NumberUtil.formatDecimal(entityState.gva_me)}
                    />
                    <SectionField
                        label="Direct Impact % of national GDP:"
                        value={
                            <Box>{NumberUtil.formatNumber(entityState.gva_per)}</Box>
                        }
                        unit="%"
                        notEmptyValue={!!NumberUtil.formatNumber(entityState.gva_per)}
                    />
                    <SectionField
                        label="Direct Impact:"
                        value={
                            <Box>{NumberUtil.formatDecimal(entityState.di_gva_me)}</Box>
                        }
                        unit="€ million"
                        notEmptyValue={
                            !!NumberUtil.formatDecimal(entityState.di_gva_me)
                        }
                    />
                    <SectionField
                        label="Indirect and induced % of national GDP:"
                        value={
                            <Box>{NumberUtil.formatNumber(entityState.di_gva_per)}</Box>
                        }
                        unit="%"
                        notEmptyValue={
                            !!NumberUtil.formatNumber(entityState.di_gva_per)
                        }
                    />
                    <SectionField
                        label="Total Impact:"
                        value={
                            <Box>
                                {NumberUtil.formatDecimal(entityState.tii_gva_me)}
                            </Box>
                        }
                        unit="€ million"
                        notEmptyValue={
                            !!NumberUtil.formatDecimal(entityState.tii_gva_me)
                        }
                    />
                    <SectionField
                        label="Total Impact % of national GDP:"
                        value={
                            <Box>
                                {NumberUtil.formatNumber(entityState.tii_gva_per)}
                            </Box>
                        }
                        unit="%"
                        notEmptyValue={
                            !!NumberUtil.formatNumber(entityState.tii_gva_per)
                        }
                    />
                    <SectionField
                        label="Current Employment:"
                        value={<Box>{NumberUtil.formatDecimal(entityState.emp_n)}</Box>}
                        unit="Nº Persons"
                        notEmptyValue={!!NumberUtil.formatDecimal(entityState.emp_n)}
                    />
                    <SectionField
                        label="Indirect and induced Employment in the country:"
                        value={
                            <Box>{NumberUtil.formatNumber(entityState.emp_per)}</Box>
                        }
                        unit="%"
                        notEmptyValue={!!NumberUtil.formatNumber(entityState.emp_per)}
                    />
                    <SectionField
                        label="Direct Impact Employment:"
                        value={
                            <Box>{NumberUtil.formatDecimal(entityState.di_emp_n)}</Box>
                        }
                        unit="Nº Persons"
                        notEmptyValue={!!NumberUtil.formatDecimal(entityState.di_emp_n)}
                    />
                    <SectionField
                        label="Direct Impact Employment:"
                        value={
                            <Box>{NumberUtil.formatNumber(entityState.di_emp_per)}</Box>
                        }
                        unit="%"
                        notEmptyValue={
                            !!NumberUtil.formatNumber(entityState.di_emp_per)
                        }
                    />
                    <SectionField
                        label="Total Employment:"
                        value={
                            <Box>{NumberUtil.formatDecimal(entityState.tii_emp_n)}</Box>
                        }
                        unit="Nº Persons"
                        notEmptyValue={
                            !!NumberUtil.formatDecimal(entityState.tii_emp_n)
                        }
                    />
                    <SectionField
                        label="Total Employment:"
                        value={
                            <Box>
                                {NumberUtil.formatNumber(entityState.tii_emp_per)}
                            </Box>
                        }
                        unit="%"
                        notEmptyValue={
                            !!NumberUtil.formatNumber(entityState.tii_emp_per)
                        }
                    />
                    <SectionField
                        label="Top 5 non-MSP sectors impacted:"
                        value={entityState.top5}
                    />
                </SectionCard>
            </EntityViewPanel>
        )
    );
};
